interface Props {
  selected: boolean;
}
const SvgAuthMail: React.FC<Props> = ({ selected }) => {
  return (
    <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_13217_8297)">
        <path
          d="M4.4375 3.5C3.09802 3.5 2 4.59802 2 5.9375V13.0625C2 14.402 3.09802 15.5 4.4375 15.5H14.5625C15.902 15.5 17 14.402 17 13.0625V5.9375C17 4.59802 15.902 3.5 14.5625 3.5H4.4375ZM4.4375 4.625H14.5625C15.2938 4.625 15.875 5.20623 15.875 5.9375V6.35205L9.5 9.7981L3.125 6.35205V5.9375C3.125 5.20623 3.70623 4.625 4.4375 4.625ZM3.125 7.63086L9.23267 10.9326C9.31479 10.977 9.40666 11.0002 9.5 11.0002C9.59334 11.0002 9.68521 10.977 9.76733 10.9326L15.875 7.63086V13.0625C15.875 13.7938 15.2938 14.375 14.5625 14.375H4.4375C3.70623 14.375 3.125 13.7938 3.125 13.0625V7.63086Z"
          fill={selected ? "white" : "#2B2B2B"}
        />
      </g>
      <defs>
        <clipPath id="clip0_13217_8297">
          <rect width="18" height="18" fill="white" transform="translate(0.5 0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgAuthMail;
